export default __webpack_public_path__ + "static/media/iconFirstStep.546a1c68.svg";